module.exports = __webpack_public_path__ + "img/downloadjindu.b2b5f1ef.png";